import ReactGA from 'react-ga4';

import { GA_IDS } from 'shared/consts';
import { GaEvents } from 'shared/typings';

import { debugLogHelper } from './gaDebugLog';
import { getGaParams } from './getGaParams';

const debugMode = import.meta.env.VITE_ANALYTICS_DEBUG_MODE === 'true';

export const sendGaEvent = (eventName: string, eventOptions: GaEvents = {} as GaEvents) => {
	const ga4Params = { ...getGaParams(), ...eventOptions };

	if (debugMode) {
		debugLogHelper(eventName, ga4Params);
	} else {
		try {
			GA_IDS.filter((id) => !!id).forEach((id) => {
				ReactGA.event(eventName, { send_to: id, ...ga4Params });
			});
		} catch (error) {
			console.error('Caught error while sending GA4', error);
		}
	}
};
